module.exports = __webpack_public_path__ + "img/ip_logo.9e87b005.png";